import IAuthenticationState from "./AuthenticationState";

export const initState: IAuthenticationState = {
    isAuth: false,
    authOperatorId: 0,
    isAuthInProgress: false,
}